import { linkResolver } from "@temp/@prismic/prismic-config";
import { usePrismicLayout } from "@temp/@prismic/templates/PrismicLayout/hooks/usePrismicLayout";
import classNames from "classnames";
import React from "react";
import "./scss/index.scss";

function getUrlHostMatch(url) {
  var host = window.location.host;

  var _ref = new URL(url),
      urlHost = _ref.host;

  return host === urlHost;
}

export var RegionPicker = function RegionPicker() {
  var _layout$regions;

  var _usePrismicLayout = usePrismicLayout(),
      layout = _usePrismicLayout.layout;

  return React.createElement("ul", {
    className: "locales__regions-list"
  }, layout === null || layout === void 0 ? void 0 : (_layout$regions = layout.regions) === null || _layout$regions === void 0 ? void 0 : _layout$regions.map(function (region, index) {
    var _region$flag;

    var link = linkResolver(region.link);
    var isRegionActive = getUrlHostMatch(link);
    return React.createElement("li", {
      key: index,
      className: classNames("locales__regions-list-item", {
        "locales__regions-list-item--active": isRegionActive
      })
    }, React.createElement("a", {
      href: link,
      target: "_blank",
      rel: "noreferrer"
    }, React.createElement("img", {
      src: (_region$flag = region.flag) === null || _region$flag === void 0 ? void 0 : _region$flag.url,
      alt: "".concat(region.region_title, " flag")
    }), region.region_title));
  }));
};